import logoBrastemp1x from '@assets/img/logo-brastemp.png';
import logoBrastemp2x from '@assets/img/logo-brastemp@2x.png';
import logoBrastemp3x from '@assets/img/logo-brastemp@3x.svg';
import logoCompraCerta1x from '@assets/img/logo-compracerta.png';
import logoCompraCerta2x from '@assets/img/logo-compracerta@2x.png';
import logoCompraCerta3x from '@assets/img/logo-compracerta@3x.svg';
import logoConsul1x from '@assets/img/logo-consul.png';
import logoConsul2x from '@assets/img/logo-consul@2x.png';
import logoConsul3x from '@assets/img/logo-consul@3x.svg';
import logoTheBar1x from '@assets/img/logo-thebar.png';
import logoTheBar2x from '@assets/img/logo-thebar@2x.png';
import logoTheBar3x from '@assets/img/logo-thebar@3x.svg';

const LOGOS = [
  {
    img1x: logoBrastemp1x,
    img2x: logoBrastemp2x,
    img3x: logoBrastemp3x,
    imgAlt: 'Logo Brastemp',
    link: 'https://www.brastemp.com.br/',
  },
  {
    img1x: logoCompraCerta1x,
    img2x: logoCompraCerta2x,
    img3x: logoCompraCerta3x,
    imgAlt: 'Logo Compra Certa',
    link: 'https://www.compracerta.com.br/',
  },
  {
    img1x: logoConsul1x,
    img2x: logoConsul2x,
    img3x: logoConsul3x,
    imgAlt: 'Logo Consul',
    link: 'https://loja.consul.com.br/',
  },
  {
    img1x: logoTheBar1x,
    img2x: logoTheBar2x,
    img3x: logoTheBar3x,
    imgAlt: 'Logo The Bar',
    link: 'https://br.thebar.com/',
  },
];

export default LOGOS;
